import http from 'axios'

export default {
  getDetailMouvement: (username, numeroBon, numeroContrat) => {
    return http.get(`/web/v1/${username}/mouvement/${numeroBon}/contrat/${numeroContrat}/details`)
  }
}
